import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { closeMainModal } from "../../Redux/UI/actions";

class MainModal extends PureComponent {
  style = {
    closed: {
      display: "block",
      pointerEvents: "none",
    },
    wrapperOpenedStyle: {
      display: "block",
      opacity: 1,
      background: "rgba(0, 0, 0, 0.5)",
    },

    dialogOpenedStyle: {
      transform: "translate(0, 0)",
    },
  };

  closeMainModal = () => {
    const { closeCB, onCloseMainModal } = this.props;
    if (closeCB) {
      closeCB();
    }
    onCloseMainModal();
  };

  secondaryBtn = () => {
    const { btnSecondaryCb, btnSecondaryLabel, onCloseMainModal } = this.props;

    if (!btnSecondaryLabel) {
      return null;
    }

    const onClick = () => {
      if (btnSecondaryCb) {
        btnSecondaryCb();
      }
      onCloseMainModal();
    };

    return (
      <button
        type="button"
        className="btn btn-primary header-modal-btn"
        onClick={onClick}
      >
        {btnSecondaryLabel}
      </button>
    );
  };

  render = () => {
    const { isOpen, content, title, btnLabel } = this.props;

    return (
      <div
        className="modal fade add-item item-details-modal"
        style={isOpen ? this.style.wrapperOpenedStyle : this.style.closed}
      >
        <div
          className="modal-dialog modal-lg"
          style={isOpen ? this.style.dialogOpenedStyle : null}
        >
          <div className="modal-content">
            <div className="modal-header">
              {this.secondaryBtn()}
              <button
                type="button"
                className="btn btn-primary header-modal-btn"
                onClick={this.closeMainModal}
              >
                {btnLabel}
              </button>
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">{content}</div>
          </div>
        </div>
      </div>
    );
  };
}

MainModal.propTypes = {};

const mapStateToProps = (state) => ({
  isOpen: state.ui.mainModalOpen,
  content: state.ui.mainModelContent,
  title: state.ui.mainModelTitle,
  closeCB: state.ui.mainModelCloseCB,
  btnLabel: state.ui.mainModelBtnLabel,
  btnSecondaryCb: state.ui.mainModelSecondaryCloseCB,
  btnSecondaryLabel: state.ui.mainModelBtnSecondaryLabel,
});

const mapDispatchToProps = (dispatch) => ({
  onCloseMainModal: () => dispatch(closeMainModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MainModal);
